import React, { useEffect, useState } from "react"
import axios from 'axios'
import { useNavigate, Link } from 'react-router-dom'
import { handleChange, handleBlur, setInputValues } from '../../components/Form'
import PulseLoader from "react-spinners/PulseLoader"
import { authenticate } from "../../helpers/helpers"
import '../../style/auth/auth.css'

const Signin = () => {
    const [buttonText, setButtonText] = useState('Prihlásiť sa')
    const [error, setError] = useState('')
    const [values, setValues] = useState()
    const navigate = useNavigate()

    useEffect(() => { setInputValues(['email', 'password'], setValues) }, [])

    const handleSubmit = (event) => {
        event.preventDefault()
        setButtonText('loader')
        axios({
            method: 'POST',
            url: `${process.env.REACT_APP_API}/auth/signin`,
            data: Object.keys(values).reduce((obj, key) => { obj[key] = values[key].value; return obj; }, {})
        })
            .then(response => {
                authenticate(response, () => navigate('/home'))
            })
            .catch(error => {
                let copyOfValues = values
                copyOfValues.password.value = ''
                Object.keys(copyOfValues).map(key => copyOfValues[key].isActivated = false)
                setValues(copyOfValues)
                setButtonText('Prihlásiť sa')
                if (error?.response?.data) {
                    setError(error.response.data.error)
                }
            })
    }

    return (
        <div className="auth-page">
            <a href="/" className="auth-logo">Arbitrage<span>.sk</span></a>

            <div className="auth-card">
                <h1 className="auth-title">Vitajte späť</h1>
                <p className="auth-subtitle">Prihláste sa a pokračujte v zárabaní.</p>

                <form onSubmit={handleSubmit}>
                    <div className="auth-field">
                        <label className="auth-label">Email</label>
                        <input
                            className="auth-input"
                            type="email"
                            name="email"
                            placeholder="vas@email.sk"
                            value={values?.email?.value || ''}
                            onChange={e => handleChange(e, values, setValues)}
                            onBlur={e => handleBlur(e, values, setValues)}
                        />
                    </div>

                    <div className="auth-field">
                        <label className="auth-label">Heslo</label>
                        <input
                            className="auth-input"
                            type="password"
                            name="password"
                            placeholder="Vaše heslo"
                            value={values?.password?.value || ''}
                            onChange={e => handleChange(e, values, setValues)}
                            onBlur={e => handleBlur(e, values, setValues)}
                        />
                    </div>

                    <Link to="/forgot-password" className="auth-forgot">Zabudnuté heslo?</Link>

                    <div className="auth-error">{error}</div>

                    <button className="auth-btn" type="submit" disabled={buttonText === 'loader'}>
                        {buttonText === 'loader'
                            ? <PulseLoader color="#fff" size={8} margin={4} speedMultiplier={0.9} />
                            : <><i className="fas fa-sign-in-alt"></i> {buttonText}</>
                        }
                    </button>
                </form>
            </div>

            <p className="auth-footer">
                Ešte nemáš účet? <Link to="/signup">Registrovať sa zadarmo</Link>
            </p>

            <div className="auth-trust">
                <span className="auth-trust-item"><i className="fas fa-lock"></i> Zabezpečené SSL</span>
                <span className="auth-trust-item"><i className="fas fa-check"></i> 100% legálne</span>
                <span className="auth-trust-item"><i className="fas fa-shield-alt"></i> Vaše dáta sú chránené</span>
            </div>
        </div>
    )
}

export default Signin
